import { View, Text } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { trpc } from '../lib/trpc';
import { AvatarMenu } from './AvatarMenu';

/**
 * Persistent top bar for mobile / narrow web. Renders the Per Diem brand on
 * the left and the account avatar menu on the right so Profile, Settings,
 * and Sign out are reachable from any authenticated screen.
 */
export function MobileTopBar({
  accessLimited = false,
  isDemo = false,
}: {
  accessLimited?: boolean;
  isDemo?: boolean;
}) {
  const profilesQ = trpc.profiles.list.useQuery();
  const me = profilesQ.data?.find((p) => p.isSelf) ?? profilesQ.data?.[0];

  return (
    <View className="flex-row items-center justify-between px-4 pt-2 pb-2">
      <View className="flex-row items-center gap-2.5">
        <View className="w-7 h-7 rounded-lg bg-forest-600 items-center justify-center">
          <Ionicons name="leaf" size={14} color="#ffffff" />
        </View>
        <View>
          <Text className="text-base font-bold text-gray-900 dark:text-gray-100 tracking-tight leading-tight">
            Per Diem
          </Text>
          <Text className="text-[10px] text-gray-400 dark:text-gray-500 -mt-0.5">
            Every day matters
          </Text>
        </View>
      </View>
      <AvatarMenu
        firstName={me?.firstName}
        lastName={me?.lastName}
        source="mobile_top_bar"
        showProfile={!accessLimited}
        showIntegrations={!accessLimited}
        disableSupport={isDemo}
      />
    </View>
  );
}
